import React from 'react';
import { Container, Typography, Box, Divider } from '@mui/material';

function formatPrivacy(text) {
  const headings = [
    'How We Collect Information',
    'Information You Provide',
    'Information from Website Use',
    'Cookies',
    'How We Use and Share Your Information',
    'Communications from Us',
    'Accessing and Managing Your Information',
    'Controlling Your Data',
    'Data Security',
    'Questions or Concerns',
    'Policy Updates'
  ];
  let formatted = text;
  headings.forEach(h => {
    const regex = new RegExp(`(^|\\n)(${h})`, 'g');
    formatted = formatted.replace(
      regex,
      `$1<span class="privacy-heading">${h}</span>`
    );
  });
  return formatted;
}

const privacyText = `
Indian Book House values your privacy and is dedicated to safeguarding your personal information. This Privacy Policy explains how we collect, use, and manage your data, and outlines your rights under applicable privacy laws, including the General Data Protection Regulation (GDPR).

We believe you should have control over your personal information. Unless you give us explicit consent, we will only collect and use your data as described in this policy.

Your rights include:
- Being informed about how your data is used.
- Accessing your information.
- Requesting corrections to your data.
- Requesting deletion of your data.
- Restricting how your data is processed.
- Data portability.
- Objecting to certain uses of your data.
- Rights related to automated decision-making and profiling.

How We Collect Information
We only collect your personal information with your consent. This may happen when you:
- Provide your details to us directly.
- Place an order or purchase products/services.
- Register or enter information on our website.
- Participate in promotions or competitions.
- Interact with us on social media.
- Contact our customer service team.

Information You Provide
We store information you enter in your account, such as your name, address, phone number, email, order history, and communication preferences. We also keep records of your interactions with our customer service team.

Information from Website Use
We collect technical data when you browse our website, such as browser type, device, IP address, and usage patterns. This helps us improve your experience and our services.

Cookies
Our website uses cookies to enhance your browsing experience, remember your preferences, and provide personalized content. You can disable cookies in your browser settings, but some features may not work as intended.

How We Use and Share Your Information
We use your information to:
- Process and fulfill your orders.
- Provide updates and information relevant to you.
- Share special offers and event details.
- Improve our products and services.

We do not share your personal information with advertisers. We may use trusted service providers, including those overseas, for purposes such as fraud detection and order processing, always in compliance with privacy laws. We will not disclose your information to third parties without your consent, except as required by law or to protect the safety of others.

Communications from Us
You can manage your communication preferences in your account settings. You may receive updates about your orders, new products, services, and special offers. You can unsubscribe from marketing emails at any time.

Accessing and Managing Your Information
You can view and edit your personal information by logging into your account. If you have questions or need help updating or deleting your data, please contact our customer service team.

Controlling Your Data
You can:
- Edit your account information at any time.
- Contact our customer service team to update or delete your data (except where required for legal or order fulfillment purposes).
- Manage your email preferences in your account.
- Delete cookies or use your browser’s private browsing mode.

Data Security
We take reasonable steps to protect your personal information. Access is restricted to authorized staff, and we use industry-standard security measures. However, no system is completely secure, and we cannot guarantee absolute protection against unauthorized access.

Questions or Concerns
If you have any questions or concerns about our Privacy Policy or how your data is handled, please contact us at +919311051039, Monday to Friday, 9am to 5pm IST (excluding public holidays).

Policy Updates
As our business evolves, we may update this Privacy Policy. Any changes will be posted on our website and will apply from the date of posting, regardless of whether you receive specific notice.

Thank you for trusting Indian Book House with your information.
`;

const PrivacyPolicy = () => (
  <Container maxWidth="xl" sx={{ py: 4 }}>
    <Typography variant="h4" fontWeight={600} sx={{ mb: 2, fontFamily: 'Poppins' }}>
      Privacy Policy
    </Typography>
    <Divider sx={{ mb: 0 }} />
    <Box
      sx={{
        fontFamily: 'Poppins',
        fontSize: '14px',
        color: '#222',
        lineHeight: 1.7,
        whiteSpace: 'pre-line'
      }}
      dangerouslySetInnerHTML={{
        __html: formatPrivacy(privacyText)
      }}
    />
    <style>
      {`
        .privacy-heading {
          display: block;
          font-weight: bold;
          font-size: 1.08em;
          margin-top: 1.2em;
          margin-bottom: 0.4em;
        }
      `}
    </style>
  </Container>
);

export default PrivacyPolicy;